// extracted by mini-css-extract-plugin
module.exports = {"presenter":"default_presenter__Oap63","headline":"default_headline__3hyaf"};